import React from "react";

import { HealthIndexDetailsInput } from "./HealthIndex";
import { LocationAlertType } from "../../../../../models/LocationAlert";

export interface DetailsInputProps {
  type: LocationAlertType;
}

export const DetailsInput: React.FC<DetailsInputProps> = ({ type }) => {
  switch (type) {
    case LocationAlertType.HEALTH_INDEX:
      return <HealthIndexDetailsInput />;
    default:
      return null;
  }
};
